import { includes, get, forEach, isBoolean, isNil } from 'lodash';
import turf from '@turf/turf';

/**
 * Parses the GeoJSON and returns the desirable table estructure.
 *
 * @param {object} geojson - The csv layer.
 * @returns {object} An object containing the two arrays needed for the table.
 */
const parseGeoJSONTable = geojson => {
  const tableTitle = [];
  const tableBody = [];
  const coordinates = [];
  const type = [];

  turf.featureEach(geojson, currentFeature => {
    const currentProperties = get(currentFeature, 'properties', {});
    forEach(currentProperties, (value, prop) => {
      if (!includes(tableTitle, prop)) tableTitle.push(prop);
    });
  });
  turf.featureEach(geojson, currentFeature => {
    const currentProperties = get(currentFeature, 'properties', {});
    const featureArray = [];
    forEach(tableTitle, prop => {
      if (!isNil(currentProperties[prop])) featureArray.push(currentProperties[prop]);
      else if (isBoolean(currentProperties[prop])) featureArray.push(`${currentProperties[prop]}`);
      else featureArray.push('-');
    });
    tableBody.push(featureArray);
    coordinates.push(currentFeature.geometry.coordinates);
    type.push(currentFeature.geometry.type);
  });
  return { tableBody, tableTitle, coordinates, type };
};

export default parseGeoJSONTable;
